import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { MasterInfoState, initialMasterInfoState } from './definitions/MasterInfoState';
import { actions } from '../../modules/Actions';

export const MasterInfoReducer = reducerWithInitialState(initialMasterInfoState).case(
  actions.fetchMasterInfo,
  (state: MasterInfoState, payload: MasterInfoState) => {
    return {
      ...state,
      ...payload,
    };
  }
);
